<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
========================================================================================== -->

<template>
  <footer class="the-footer flex-wrap justify-center mb-10">
    <div class="flex flex-col justify-center items-center">
      <span
        >Copyright &copy; {{ new Date().getFullYear() }}
        <a href="https://duotalk.io" target="_blank" rel="nofollow">duotalk</a>,
        todos os direitos reservados. v{{ appVersion }} [{{ apiVersion }}]</span
      >
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    appVersion: {
      type: String,
      required: false,
      default: () => "0",
    },
  },
  computed: {
    apiVersion() {
      if (this.$store.state.acc.current_acc.versionNamespace === "v1")
        return "VIP (v1)";
      if (this.$store.state.acc.current_acc.versionNamespace === "v2")
        return "Tier (v2)";
      if (this.$store.state.acc.current_acc.versionNamespace === "v3")
        return "Beta (v3)";
      return "legacy";
    },
  },
};
</script>
